import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class PageVisitService {
  private key = 'pageVisitCount';
  private markPageVisitKey = 'markPageVisit';
  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.incrementPageVisitCount();
      }
    });
  }

  incrementPageVisitCount() {
    const count = +(localStorage.getItem(this.key) || 0);
    localStorage.setItem(this.key, (count + 1).toString());
    
  }

  getPageVisitCount(): number {
    return +(localStorage.getItem(this.key) || 0);
  }

  resetPageVisitCount() {
    localStorage.removeItem(this.key);
  }

  markPageVisit() {
    localStorage.setItem(this.markPageVisitKey, '1'); 
  }

  isPageVisitMarked(): boolean {
    return localStorage.getItem(this.markPageVisitKey) === '1';
  }
} 